import React, { Component } from 'react'
import { Layer, Box, Text } from 'grommet';
import ButtonBlue from '../Utils/buttonBlue';
import { withRouter } from "react-router-dom";

class ModalPasswordResponse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            result: this.props.resultOperation, title: '', text: ''
        }
        this.resetstate = this.resetstate.bind(this);
    }

    resetstate(){
        this.setState({
            oldPassword: '',
            newPassword: '',
            msgPassOld: '',
            msgPassNew: '',
            msgPassConf: '',
            msgOtp: '',
            errorOtp: false,
            otp: '',
            confirmNewPassword: '',
            pwdValid: false,
            oldPwdValid: false,
            confPwdValid: false,
            disableButtonNewPwd: true,
            buttonStateOtp: false,
            dataOTP: false,
            errorOld: false,
            errorNew: false,
            errorConf: false,
            step: 1,
            status: '',
            showTimeoutModal: false,
            loading: false,
            updatePassword: this.props.updatePassword !== undefined && this.props.updatePassword ? true : false
        })
    }

    messageResponse(status) {
        if (status === 200) {
            this.setState({
                title: 'Modifica Password',
                text: 'La modifica della password è avvenuta con successo.'
            })

        } else {
            this.setState({
                title: 'Modifica Password',
                text: 'Si è verificato un errore durante il cambio password. Controllare le credenziali inserite.'
            })
        }

    }
    componentWillMount() {
        this.messageResponse(this.state.result)
    }


    render() {


        return (
            <Layer
                flush={true}
                animate={true}
                style={{ width: '50%', height: '400px', zIndex: 100 }}
            >
                <Box
                    justify="center"
                    background='white'
                    align="center"
                    pad='large'
                    gap='small'
                >
                    <Box direction='row' alignSelf='end'>
                        <Box direction='column' alignSelf='end'>
                            <button type="button" aria-label="Chiudi finestra" title="Chiudi" style={{ background: 'none', border: 'none', padding: 0, margin: 0, position: 'absolute', top: '12px', right: '25px', cursor: 'pointer' }} onClick={this.props.close}>
  <i className='icon-close' aria-hidden="true" style={{ textAlign: 'right', fontSize: '15px', color: '#000000' }} />
</button>

                        </Box>
                    </Box>
                    <Box direction="row"
                        gap="medium"
                        pad='medium'
                        align="center">
                        <Box align='center' margin='medium' alignContent='center'>
                            <Box direction='row' alignSelf='center' >
                                <Text className='text-title-blue'  >{this.state.title}</Text>
                            </Box>
                            <Box>
                                <Text > {this.state.text}</Text>
                            </Box>
                            <Box style={{ width: '60%' }} gap='medium' className='detail-text'>
                                <ButtonBlue buttonName='CHIUDI' style={{ width: '100%' }} onClick={this.resetstate} /></Box>
                        </Box>
                    </Box>

                </Box>
            </Layer >
        )
    }
}
export default ModalPasswordResponse = withRouter(ModalPasswordResponse);
